import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuList from '@mui/material/MenuList';
import { useState } from 'react';
import * as React from 'react';

interface IRowMenu {
  dataTestId?: string;
  menuItems: React.ReactNode;
}

function RowMenu({ dataTestId, menuItems }: IRowMenu) {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  function handleToggle(event: React.MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
    setOpen((prev) => !prev);
    event.stopPropagation();
  }

  function handleClose() {
    setOpen(false);
    setAnchorEl(null);
  }

  return (
    <Box id="row-menu">
      <IconButton aria-controls="row-menu-list-grow" data-testid={dataTestId} onClick={handleToggle} sx={{ color: 'secondary.main' }}>
        <MoreHorizIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} onClose={handleClose} open={Boolean(open)}>
        <MenuList
          disablePadding
          onClick={handleClose}
          sx={{
            '& .MuiListItemIcon-root': {
              color: 'secondary.main',
              mx: 1,
            },
            '& .MuiMenuItem-root': {
              height: 48,
              p: 2,
            },
          }}
        >
          {menuItems}
        </MenuList>
      </Menu>
    </Box>
  );
}

export default RowMenu;
